import { useLocationStore } from '@ahm/react-map/store';
import { useMemo } from 'react';
import {
  createTranslations,
  locales as localizes,
  type Locales,
} from '../locales';

export default function useAutocompleteText({
  lang = 'vi',
  pointType,
  placeholder,
}: {
  lang?: keyof Locales;
  pointType?: 'pickup' | 'dropoff';
  placeholder?: string;
}) {
  const t = createTranslations({ locales: localizes, lang });

  const currentLocation = useLocationStore.use.currentLocation();
  const loadingLocation = useLocationStore.use.loading();
  const errorLocation = useLocationStore.use.error();

  const inputPlaceholder = useMemo(() => {
    if (pointType) {
      return pointType === 'pickup'
        ? t('where_do_you_want_to_pickup')
        : t('where_do_you_send');
    }

    return placeholder ?? t('placeholder');
  }, [pointType, placeholder, t]);

  const currentLocationStatus = useMemo(() => {
    if (loadingLocation) {
      return t('getting_current_location');
    }

    if (errorLocation && 'code' in errorLocation) {
      switch (Number(errorLocation.code)) {
        case 1:
          return t('error_permission_denied');
        case 2:
          return t('error_get_current_location');
        default:
          return t('error_timeout_expired');
      }
    }

    return t('use_current_location');
  }, [currentLocation?.address, errorLocation, loadingLocation, t]);

  return { inputPlaceholder, currentLocationStatus };
}
